module.exports = __webpack_public_path__ + "logo-orkla-tagline-dk-white-1e8c1ad574f969c8864681e4e8429eb9.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-dk-white.svg
// module id = 61
// module chunks = 0